import { render, staticRenderFns } from "./ChannelModal.vue?vue&type=template&id=1d7bdd9d&scoped=true"
import script from "./ChannelModal.vue?vue&type=script&lang=js"
export * from "./ChannelModal.vue?vue&type=script&lang=js"
import style0 from "./ChannelModal.vue?vue&type=style&index=0&id=1d7bdd9d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7bdd9d",
  null
  
)

export default component.exports